const contributions = [
	{
		project: 'Hyper',
		author: 'Zeit',
		bounce: 'bounceInLeft',
		description:
			'Added a text search feature such that one is able to search for words in their terminal output.',
		link: 'https://github.com/zeit/hyper/pull/3075'
	},
	{
		project: 'Hyper',
		author: 'Zeit',
		bounce: 'bounceInRight',
		description: 'Tabs show current working directory in title.',
		link: 'https://github.com/zeit/hyper/pull/3015'
	},
	{
		project: 'Perfected Prototypes',
		author: 'El-Dringo-Brannde',
		bounce: 'bounceInLeft',
		description:
			'Owner of the Perfected Prototype project, extending the prototype chains of common types in Javascript',
		link: 'https://github.com/El-Dringo-Brannde/Perfected-Prototypes'
	},
	{
		project: 'Bonsai',
		author: 'Nicholas Nelson',
		bounce: 'bounceInRight',
		description:
			'Main contributor of the Bonsai project, developing a new text editor under the guise of text editors are cards.',

		link: 'https://github.com/nelsonni/bonsai'
	},
	{
		project: 'Gimme-AWS-Creds',
		author: 'Nike Inc.',
		bounce: 'bounceInLeft',
		description:
			"Created the Github contributing template for PR's and issues",

		link: 'https://github.com/nelsonni/bonsai'
	},
	{
		project: 'Gimme-AWS-Creds',
		author: 'Nike Inc.',
		bounce: 'bounceInLeft',
		description:
			"Fixed bug that wasn't allowing users to create multiple profiles for an AWS account",

		link: 'https://github.com/Nike-Inc/gimme-aws-creds/pull/103'
	},
	{
		project: 'Gimme-AWS-Creds',
		author: 'Nike Inc.',
		bounce: 'bounceInLeft',
		description:
			'Created feature that allows users to see all the profiles that they have created with Okta.',
		link: 'https://github.com/Nike-Inc/gimme-aws-creds/pull/104'
	},{
		project: 'Middlemen', 
		description: 'Created NPM package where you can add middleware to your Azure functions, taking care of token validation, input validation, etc. prior to business logic.',
		bounce: 'bounceInLeft',
		language: ['Typescript'], 
		link: 'https://github.com/El-Dringo-Brannde/Middlemen'
	}
];

export default contributions;
